let wc_th_pb_bb_shop_money=document.querySelector(".th_custom_work_money_format").dataset.wc_th_money_format;
var Shopify = Shopify || {}; Shopify.money_format = wc_th_pb_bb_shop_money, Shopify.formatMoney = function (a, e) { "string" == typeof a && (a = a.replace(".", "")); var o = "", r = /\{\{\s*(\w+)\s*\}\}/, t = e || this.money_format; function n(a, e) { return void 0 === a ? e : a } function i(a, e, o, r) { if (e = n(e, 2), o = n(o, ","), r = n(r, "."), isNaN(a) || null == a) return 0; var t = (a = (a / 100).toFixed(e)).split("."); return t[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (t[1] ? r + t[1] : "") } switch (t.match(r)[1]) { case "amount": o = i(a, 2); break; case "amount_no_decimals": o = i(a, 0); break; case "amount_with_comma_separator": o = i(a, 2, ".", ","); break; case "amount_no_decimals_with_comma_separator": o = i(a, 0, ".", ",") }return t.replace(r, o) };
let th_returns_format_money = (final) => { return Shopify.formatMoney(final, wc_th_pb_bb_shop_money) }
let fbt_add_to_cart_loader='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" height="30px" width="30px"><circle fill="white" stroke="white" stroke-width="15" r="15" cx="40" cy="65"><animate attributeName="cy" calcMode="spline" dur="2" values="65;135;65;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.4"/></circle><circle fill="white" stroke="white" stroke-width="15" r="15" cx="100" cy="65"><animate attributeName="cy" calcMode="spline" dur="2" values="65;135;65;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.2"/></circle><circle fill="white" stroke="white" stroke-width="15" r="15" cx="160" cy="65"><animate attributeName="cy" calcMode="spline" dur="2" values="65;135;65;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="0"/></circle></svg>'
let th_smart_bundles=[];
  const th_custom_fbt_bundle_cta_ajax_event = async function (th_custom_bundle_fbt_form_data) {
              const th_addtocart_result = await fetch('/cart/add.json', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(th_custom_bundle_fbt_form_data)
                });
                return th_addtocart_result.json();
  }
let $th_bundle_success_callback= async (id,$th_bundle_result)=>{
   //product bundle code starts from here
       let th_product_bundles_detail=$th_bundle_result.bundle_list;
       let th_product_bundle_logic_for_compare_price=(th_product_bundles)=>{
             th_product_bundles.forEach((th_pro_bundle)=>{
             let th_pro_bundle_id=th_pro_bundle.dataset.bundle;
             let th_current_product_bundles_detail=th_product_bundles_detail.find((bundle)=>bundle.bundle_detail.id==th_pro_bundle_id);
    
             let th_product_grids=th_pro_bundle.querySelectorAll('.li_product_list');
             th_product_grids.forEach((th_pro_grid)=>{
               let th_grid_product_main_select_element=th_pro_grid.querySelector('.th_pb_pro_variants');
               let th_grid_product_price_element=th_pro_grid.querySelector('.th_pb_list_price');
               let th_custom_compare_price=th_pro_grid.querySelector('.th_custom_compare_price .money');
               let th_product_id=th_pro_grid.dataset.id;
               let th_selected_variant_id=th_grid_product_main_select_element.options[th_grid_product_main_select_element.selectedIndex].value;
               let th_product_from_bundle_detail=th_current_product_bundles_detail.product_list.find((signle_bundle_product)=>signle_bundle_product.id==th_product_id);
               let variant_from_product_bundle_detail=th_product_from_bundle_detail.variants.find((filter_variant)=>filter_variant.id==th_selected_variant_id)
               let th_compare_price=variant_from_product_bundle_detail.compare_at_price;                                                                                
               if(th_compare_price!=0 && th_compare_price!=undefined){
                 if(!th_custom_compare_price){
                   th_grid_product_price_element.innerHTML+=`<span class="th_custom_compare_price"><span class='money'>${th_returns_format_money(th_compare_price*100)}</span></span>`
                 }else{th_custom_compare_price.innerText=th_returns_format_money(th_compare_price*100)}
               }else{
                 if(th_custom_compare_price)(th_custom_compare_price.remove())
               }
             })
           })
       }
       if(th_product_bundles_detail && th_product_bundles_detail.length>0){
         let th_product_bundles=document.querySelectorAll('.th_pb_innercode.th_pb_wf');
         if(th_product_bundles.length>0){
           th_product_bundle_logic_for_compare_price(th_product_bundles);
           th_product_bundles.forEach((th_pro_bundle)=>{
             let th_product_grids=th_pro_bundle.querySelectorAll('.li_product_list');
               th_product_grids.forEach((th_pro_grid)=>{
               let th_grid_product_main_select_element=th_pro_grid.querySelector('.th_pb_pro_variants');
               let th_seprate_select_elements=th_pro_grid.querySelectorAll('.th_pb_option_select_cls');
               th_grid_product_main_select_element.addEventListener('input',()=>{
                  th_product_bundle_logic_for_compare_price(th_product_bundles);
               })
               th_seprate_select_elements.forEach((seprate_select_box)=>{
                 seprate_select_box.addEventListener('click',()=>{
                     th_product_bundle_logic_for_compare_price(th_product_bundles);
                 })
               })
             })
           })
         }
       }
    //product bundle code ends from here


    //addon_bundle_Code--stats
    let th_addon_bundles_detail=$th_bundle_result.addon_bundle_list;
    let addon_bundle_containor=document.querySelector('.wcpb_ao_section');
    if(addon_bundle_containor){
    let addon_bundles_parent=addon_bundle_containor.querySelectorAll('.wcpb_wf.wcpb_ao_outer');
  
    let th_compare_price_logic_addon_bundle=(addon_bundles_parent)=>{
        addon_bundles_parent.forEach((addon_bundle)=>{
        let addon_bundle_id=addon_bundle.querySelector('.wcpb_wf.wcpb_ao_inner').dataset.bundle;
        let addon_product_grids=addon_bundle.querySelectorAll('.wcpb_ao_p_single_grid');
        let current_addon_bundle_detail=th_addon_bundles_detail.find((ao_bundle)=>ao_bundle.bundle_detail.id==addon_bundle_id);
       
        addon_product_grids.forEach((a_prod_grid)=>{
          let grid_product_id=a_prod_grid.dataset.pid;
          let current_product_deatail_from_bundle_deatail=current_addon_bundle_detail.product_list.find((ao_product)=>ao_product.id==grid_product_id);
          let grid_hide_select_element=a_prod_grid.querySelector('.wcpb_wf.wcpb_ao_pro_variants.wcpb_ao_main_select_hide_cls');
          let selected_variant_id=grid_hide_select_element.options[grid_hide_select_element.selectedIndex].value;
          let selected_variant_details=current_product_deatail_from_bundle_deatail.variants.find((variant)=>variant.id==selected_variant_id);
          let grid_product_price_element_parent=a_prod_grid.querySelector('.wcpb_ao_pinfo_detail_price');
          let th_custom_compare_price=a_prod_grid.querySelector('.th_custom_compare_price .money');
          let th_compare_price=selected_variant_details.compare_at_price;                                                                                
          if(th_compare_price!=0 && th_compare_price!=undefined){
              if(!th_custom_compare_price){
                 grid_product_price_element_parent.innerHTML+=`<span class="th_custom_compare_price"><span class='money'>${th_returns_format_money(th_compare_price*100)}</span></span>`;
              }else{th_custom_compare_price.innerText=th_returns_format_money(th_compare_price*100)}
          }else{
              if(th_custom_compare_price)(th_custom_compare_price.remove())
          }
        })
      })
    }
    if(addon_bundles_parent.length>0 && th_addon_bundles_detail.length>0){
      th_compare_price_logic_addon_bundle(addon_bundles_parent);

       addon_bundles_parent.forEach((addon_bundle)=>{
        let ao_bundle_seprate_selectboxs=addon_bundle.querySelectorAll('.wcpb_ao_option_select_cls');
        ao_bundle_seprate_selectboxs.forEach((seprate_selectbox)=>{
          seprate_selectbox.addEventListener('click',()=>{
            th_compare_price_logic_addon_bundle(addon_bundles_parent);
          })
        })
       })
    }
  }
  //addon_bundle_Code--ends
 
   //smart url bundle--starts
    // let smart_url_bundle_products=$th_bundle_result.product_list;
    // let th_smart_bundles_shortcode=document.querySelectorAll('.th_pb_custom_bundle');
    // if(smart_url_bundle_products && $th_bundle_result.bundle_discount==0 && th_smart_bundles_shortcode.length>0){
    //    th_smart_bundles.push($th_bundle_result);
    //    let smart_bundle_titlte=$th_bundle_result.name;
    //    th_smart_bundles_shortcode.forEach((th_smart_bundle,th_smart_bundle_index)=>{
    //      let th_smart_bundle_title=th_smart_bundle.querySelector('.th_pb_cb_main_title h2').innerText;
    //        let current_smart_bundle_detail=th_smart_bundles.find((sma_bundle)=>sma_bundle.name==th_smart_bundle_title);
    //        console.log("current_smart_bundle_detail",current_smart_bundle_detail)
    //        let th_smart_bundle_product_grids=th_smart_bundle.querySelectorAll('.th_pb_cb_li');
    //        th_smart_bundle_product_grids.forEach((smart_bb_pro_grid)=>{
    //          let grid_product_id=smart_bb_pro_grid.dataset.id;
    //          let current_product_details_from_bundle_datails=smart_url_bundle_products.find((smart_product)=>smart_product.id==grid_product_id);
    //          let grid_select_element=smart_bb_pro_grid.querySelector('.th_pb_cb_select');
    //          let select_element_variant_id=grid_select_element.options[grid_select_element.selectedIndex].value;
    //          let variant_details_from_product_details_json=current_product_details_from_bundle_datails.variants.find((variant)=>variant.id==select_element_variant_id);
    //          let th_compare_price=variant_details_from_product_details_json.compare_at_price;  
    //          let th_custom_compare_price=smart_bb_pro_grid.querySelector('.th_custom_compare_price .money');
    //          let th_grid_product_price_element=smart_bb_pro_grid.querySelector('.th_pb_cb_price .th_pb_wf');
    //            if(th_compare_price!=0 && th_compare_price!=undefined){
    //              if(!th_custom_compare_price){
    //                th_grid_product_price_element.innerHTML+=`<span class="th_custom_compare_price"><span class='money'>${th_returns_format_money(th_compare_price*100)}</span></span>`;
    //              }else{th_custom_compare_price.innerText=th_returns_format_money(th_compare_price*100)}
    //            }else{
    //              if(th_custom_compare_price)(th_custom_compare_price.remove());
    //            }
    //        })
    //    })
    // }

      let smart_url_bundle_products=$th_bundle_result.product_list;
      let th_smart_bundles_shortcode=document.querySelectorAll('.th_pb_custom_bundle');
      let th_smart_bundle_compare_price_logic=(th_smart_bundles_shortcode)=>{
        th_smart_bundles_shortcode.forEach((th_smart_bundle)=>{
          let th_smart_bundle_title=th_smart_bundle.querySelector('.th_pb_cb_main_title h2').innerText;
          let current_bundle_detail=th_smart_bundles.find((sma_bundle)=>th_smart_bundle_title==sma_bundle.name);
          if(current_bundle_detail && current_bundle_detail.bundle_discount==0 && current_bundle_detail.name==th_smart_bundle_title){
             let th_smart_bundle_product_grids=th_smart_bundle.querySelectorAll('.th_pb_cb_li');
                th_smart_bundle_product_grids.forEach((smart_bb_pro_grid)=>{
                 let grid_product_id=smart_bb_pro_grid.dataset.id;
                 let current_product_details_from_bundle_datails=current_bundle_detail.product_list.find((smart_product)=>smart_product.id==grid_product_id);
                 let grid_select_element=smart_bb_pro_grid.querySelector('.th_pb_cb_select');
                 let select_element_variant_id=grid_select_element.options[grid_select_element.selectedIndex].value;
                 let variant_details_from_product_details_json=current_product_details_from_bundle_datails.variants.find((variant)=>variant.id==select_element_variant_id);
                 let th_compare_price=variant_details_from_product_details_json.compare_at_price;  
                 let th_custom_compare_price=smart_bb_pro_grid.querySelector('.th_custom_compare_price .money');
                 let th_grid_product_price_element=smart_bb_pro_grid.querySelector('.th_pb_cb_price .th_pb_wf');
                   if(th_compare_price!=0 && th_compare_price!=undefined){
                     let quantity_input=th_smart_bundle.querySelector('.th_pb_cb_qty');
                     if(quantity_input){th_compare_price=th_compare_price*parseFloat(quantity_input.value)}
                     if(!th_custom_compare_price){
                       th_grid_product_price_element.innerHTML+=`<span class="th_custom_compare_price"><span class='money'>${th_returns_format_money(th_compare_price*100)}</span></span>`;
                     }else{th_custom_compare_price.innerText=th_returns_format_money(th_compare_price*100)}
                   }else{
                     if(th_custom_compare_price)(th_custom_compare_price.remove());
                   }
               })
          }
        })
      }
      if(smart_url_bundle_products && th_smart_bundles_shortcode.length>0 && $th_bundle_result.bundle_discount==0){
        th_smart_bundles.push($th_bundle_result);
        th_smart_bundle_compare_price_logic(th_smart_bundles_shortcode)
      }
      th_smart_bundles_shortcode.forEach((th_smart_bundle)=>{
         let grid_select_elements=th_smart_bundle.querySelectorAll('.th_pb_cb_select');
         let grid_quantity_inputs=th_smart_bundle.querySelectorAll('.th_pb_cb_qty_variant .th_pb_cb_qty');
         grid_select_elements.forEach((grid_select_ele)=>{
           grid_select_ele.addEventListener("input",()=>{
             th_smart_bundle_compare_price_logic(th_smart_bundles_shortcode)
           })
         })

         grid_quantity_inputs.forEach((quantity_input)=>{
           quantity_input.addEventListener("input",()=>{
             th_smart_bundle_compare_price_logic(th_smart_bundles_shortcode)
           })
         })
      })
   //smart url bundle -- ends 



   // client reuqerement for FBT bundle --starts------------------------------------------------------------------------------
   if($th_bundle_result.fbt_bundle_list && $th_bundle_result.fbt_bundle_list.length>0){
    let wc_fbt_shortcode=document.querySelector('.th_pb_fbt_section');
    if(wc_fbt_shortcode){
      if(document.querySelector('.product')){document.querySelector('.product').classList.remove('product')}
      if(document.querySelector('.urun-baslik-div')){document.querySelector('.urun-baslik-div').classList.add('new-rebolt-fbt')}
      let th_return_fbt_product_prices=(sale_price,compare_price)=>{
        let th_fbt_product_pricing='';
        th_fbt_product_pricing+=`<span class='th_fbt_product_sell_price'>${th_returns_format_money(sale_price*100)}</span>`;
        if(compare_price>sale_price){
          th_fbt_product_pricing+=`<span class='th_fbt_product_compare_price'>${th_returns_format_money(compare_price*100)}</span>`;
        }
        return th_fbt_product_pricing;
      }
      let th_return_fbt_bundle_total_pricing=(sale_price,compare_price,th_current_fbt_bundle_detail)=>{
        let th_fbt_bundle_total_pricing='';
        if(th_current_fbt_bundle_detail.bundle_detail.discount_type==null){
          th_fbt_bundle_total_pricing+=`<span class='th_custom_fbt_bundle_total_sale_price'>${th_returns_format_money(sale_price*100)}</span>`;
          if(compare_price>sale_price){
            th_fbt_bundle_total_pricing+=`<span class='th_custom_fbt_bundle_total_compare_price'>${th_returns_format_money(compare_price*100)}</span>`;
          }
        }

        return th_fbt_bundle_total_pricing;
      }
      let th_fbt_bundle_return_variant_structure=(fbt_product,th_available_variants)=>{
        let th_fbt_bundle_select_element_str='';
        let is_deafult_title=false;
        (th_available_variants.length==1 && th_available_variants[0].title=='Default Title')?is_deafult_title=true:'';
        th_fbt_bundle_select_element_str+=`<select class='th_custom_bundle_product_selecte_element ${(is_deafult_title)? 'th_hide_fbt_bundle_product_select_element':''}'>`;
            th_available_variants.forEach((variant)=>{
               let fbt_variant_image='';
               if(variant.featured_image!=null){
                 fbt_variant_image=variant.featured_image.src;
               }else{
                 if(fbt_product.featured_image!=null){
                   fbt_variant_image=fbt_product.featured_image;
                 }else{
                   fbt_variant_image='https://bundle.thimatic-apps.com/assets/img/no-product-image.svg';
                 }
               }
              th_fbt_bundle_select_element_str+=`<option data-price='${variant.price}' data-compare_at_price='${variant.compare_at_price}' data-image='${fbt_variant_image}' data-variant_id='${variant.id}' data-product_id='${fbt_product.id}'>${variant.title}</option>`;
            })
          th_fbt_bundle_select_element_str+=`</select>`;
        return th_fbt_bundle_select_element_str;
      }
      
      let th_custom_bundle_product_structure=(th_fbt_bundle)=>{
        let th_custom_fbt_bundle_product_struture=``;
        if(th_fbt_bundle.product_list && th_fbt_bundle.product_list.length>0){
          let th_fbt_products=th_fbt_bundle.product_list;
          th_fbt_products.forEach((fbt_product)=>{
             let th_available_variants=[];
             if(fbt_product.variants && fbt_product.variants.length>0){
               fbt_product.variants.forEach((variant)=>{
                 if(variant.available==true){th_available_variants.push(variant)}
               })
             }
             if(fbt_product.status!='draft' && th_available_variants.length!=0){
               let th_custom_fbt_product_grid=``;
               let fbt_product_image='';
               if(th_available_variants[0].featured_image!=null){
                 fbt_product_image=th_available_variants[0].featured_image.src;
               }else{
                 if(fbt_product.featured_image!=null){
                   fbt_product_image=fbt_product.featured_image;
                 }else{
                   fbt_product_image='https://bundle.thimatic-apps.com/assets/img/no-product-image.svg';
                 }
               }
               th_custom_fbt_product_grid+=`<div class='th_cutom_fbt_bundle_product_containor'><div class='th_cutom_fbt_bundle_product'>`;
                  th_custom_fbt_product_grid+=`<figure><a  href='/products/${fbt_product.handle}' target='blank'><img src='${fbt_product_image}' loading="lazy"></a></figure>`;
                  th_custom_fbt_product_grid+=`<div class='th_custom_fbt_bundle_product_information'>`;
                       th_custom_fbt_product_grid+=`<p class='th_custom_fbt_product_title'><a href='/products/${fbt_product.handle}' target='blank'>${fbt_product.title}</a></p>`;
                       th_custom_fbt_product_grid+=`<p class='th_custom_fbt_product_pricing'>${th_return_fbt_product_prices(th_available_variants[0].price,th_available_variants[0].compare_at_price)}</p>`;
                       th_custom_fbt_product_grid+=th_fbt_bundle_return_variant_structure(fbt_product,th_available_variants);
                       th_custom_fbt_product_grid+=`<div class="checkbox-wrapper-30 th_fbt_custom_bundle_product_checkbox_containor"><span class="checkbox"><input type="checkbox" / class='th_fbt_custom_bundle_product_checkbox' checked><svg><use xlink:href="#checkbox-30" class="checkbox"></use></svg></span><svg xmlns="http://www.w3.org/2000/svg" style="display:none"><symbol id="checkbox-30" viewBox="0 0 22 22"><path fill="none" stroke="currentColor" d="M5.5,11.3L9,14.8L20.2,3.3l0,0c-0.5-1-1.5-1.8-2.7-1.8h-13c-1.7,0-3,1.3-3,3v13c0,1.7,1.3,3,3,3h13 c1.7,0,3-1.3,3-3v-13c0-0.4-0.1-0.8-0.3-1.2"/></symbol></svg></div>`;
                       
                  th_custom_fbt_product_grid+=`</div>`;
               th_custom_fbt_product_grid+=`</div>`;

               th_custom_fbt_product_grid+=`<div class='th_custom_fbt_bundle_product_divider'><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="25px" height="25px" viewBox="0 0 32 32" version="1.1"><title>plus-circle</title><desc>Created with Sketch Beta.</desc><defs></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"><g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-466.000000, -1089.000000)" fill="#000000"><path d="M488,1106 L483,1106 L483,1111 C483,1111.55 482.553,1112 482,1112 C481.447,1112 481,1111.55 481,1111 L481,1106 L476,1106 C475.447,1106 475,1105.55 475,1105 C475,1104.45 475.447,1104 476,1104 L481,1104 L481,1099 C481,1098.45 481.447,1098 482,1098 C482.553,1098 483,1098.45 483,1099 L483,1104 L488,1104 C488.553,1104 489,1104.45 489,1105 C489,1105.55 488.553,1106 488,1106 L488,1106 Z M482,1089 C473.163,1089 466,1096.16 466,1105 C466,1113.84 473.163,1121 482,1121 C490.837,1121 498,1113.84 498,1105 C498,1096.16 490.837,1089 482,1089 L482,1089 Z" id="plus-circle" sketch:type="MSShapeGroup"></path></g></g></svg></div></div>`
               th_custom_fbt_bundle_product_struture+=th_custom_fbt_product_grid;
             }
          })
        }
        return th_custom_fbt_bundle_product_struture;
      }

      
      let wc_fbt_bundles=$th_bundle_result.fbt_bundle_list;
      let th_custom_fbt_bundle_layout='';
      wc_fbt_bundles.forEach((th_fbt_bundle)=>{
        console.log('th_fbt_bundle',th_fbt_bundle)
        let fbt_bundle_structure=``;
        fbt_bundle_structure+=`<div class='th_custom_fbt_bundle' data-th_custom_fbt_bid='${th_fbt_bundle.bundle_detail.id}'>`;
          fbt_bundle_structure+=`<div class='th_custom_bundle_header'>`;
            fbt_bundle_structure+=`<p class='th_custom_fbt_bundle_title'>${th_fbt_bundle.bundle_detail.bundle_title}</p>`;
            if(th_fbt_bundle.bundle_detail.short_desc!=''){
              fbt_bundle_structure+=`<p class='th_custom_fbt_bundle_short_description'>${th_fbt_bundle.bundle_detail.short_desc}</p>`;
            }
          fbt_bundle_structure+=`</div>`;
        fbt_bundle_structure+=`<div class='th_custom_bundle_main_containor'>`;
          fbt_bundle_structure+=`<div class='th_custom_bundle_products_containor'>`;
            fbt_bundle_structure+=th_custom_bundle_product_structure(th_fbt_bundle);
          fbt_bundle_structure+=`</div>`;
           fbt_bundle_structure+=`<div class='th_custom_fbt_bundle_bottom_section'>`;
                fbt_bundle_structure+=`<div class='th_custom_fbt_bundle_total_pricing'></div>`;
                fbt_bundle_structure+=`<div><button class='th_custom_fbt_bundle_add_to_cart_btn'>${th_fbt_bundle.bundle_detail.button_text}</button><p class='th_custom_fbt_bundle_addtocart_error'></p></div>`;
             fbt_bundle_structure+=`</div>`;
         fbt_bundle_structure+=`</div>`;
        fbt_bundle_structure+=`</div>`;

        th_custom_fbt_bundle_layout+=fbt_bundle_structure;
      })
      
       wc_fbt_shortcode.insertAdjacentHTML('afterend', th_custom_fbt_bundle_layout);

      //events starts from here
       let th_custom_fbt_bundles=document.querySelectorAll('.th_custom_fbt_bundle');
       if(th_custom_fbt_bundles.length>0){
         th_custom_fbt_bundles.forEach((th_custom_fbt_bundle)=>{
           let bundle_id=th_custom_fbt_bundle.dataset.th_custom_fbt_bid;
           let th_current_fbt_bundle_detail=wc_fbt_bundles.find((fbt_bundle)=>fbt_bundle.bundle_detail.id==bundle_id);
           let th_fbt_bundle_sale_price=0;
           let th_fbt_bundle_compare_price=0;

           let th_fbt_product_grids=th_custom_fbt_bundle.querySelectorAll('.th_cutom_fbt_bundle_product_containor');
           th_fbt_product_grids.forEach((fbt_product_grid)=>{
             let th_fbt_custom_bundle_product_checkbox=fbt_product_grid.querySelector('.th_fbt_custom_bundle_product_checkbox');
             if(th_fbt_custom_bundle_product_checkbox.checked){
               let grid_select_element=fbt_product_grid.querySelector('.th_custom_bundle_product_selecte_element');
               th_fbt_bundle_sale_price+=parseFloat(grid_select_element.options[grid_select_element.selectedIndex].dataset.price);
               th_fbt_bundle_compare_price+=parseFloat(grid_select_element.options[grid_select_element.selectedIndex].dataset.compare_at_price);
             }
           })
           let th_fbt_total_pricing_containor=th_custom_fbt_bundle.querySelector('.th_custom_fbt_bundle_total_pricing');
           th_fbt_total_pricing_containor.innerHTML=th_return_fbt_bundle_total_pricing(th_fbt_bundle_sale_price,th_fbt_bundle_compare_price,th_current_fbt_bundle_detail);
         })

         //checkbox event starts
          let th_custom_fbt_bundle_checboxes=document.querySelectorAll('.th_fbt_custom_bundle_product_checkbox');
          th_custom_fbt_bundle_checboxes.forEach((fbt_product_grid_checkbox)=>{
            fbt_product_grid_checkbox.addEventListener('change',()=>{
               let th_custom_fbt_bundle=fbt_product_grid_checkbox.closest('.th_custom_fbt_bundle');
               let bundle_id=th_custom_fbt_bundle.dataset.th_custom_fbt_bid;
               let th_current_fbt_bundle_detail=wc_fbt_bundles.find((fbt_bundle)=>fbt_bundle.bundle_detail.id==bundle_id);
               let th_fbt_bundle_sale_price=0;
               let th_fbt_bundle_compare_price=0;
    
               let th_fbt_product_grids=th_custom_fbt_bundle.querySelectorAll('.th_cutom_fbt_bundle_product_containor');
               th_fbt_product_grids.forEach((fbt_product_grid)=>{
                 let th_fbt_custom_bundle_product_checkbox=fbt_product_grid.querySelector('.th_fbt_custom_bundle_product_checkbox');
                 if(th_fbt_custom_bundle_product_checkbox.checked){
                   let grid_select_element=fbt_product_grid.querySelector('.th_custom_bundle_product_selecte_element');
                   th_fbt_bundle_sale_price+=parseFloat(grid_select_element.options[grid_select_element.selectedIndex].dataset.price);
                   th_fbt_bundle_compare_price+=parseFloat(grid_select_element.options[grid_select_element.selectedIndex].dataset.compare_at_price);
                 }
               })
               let th_fbt_total_pricing_containor=th_custom_fbt_bundle.querySelector('.th_custom_fbt_bundle_total_pricing');
               th_fbt_total_pricing_containor.innerHTML=th_return_fbt_bundle_total_pricing(th_fbt_bundle_sale_price,th_fbt_bundle_compare_price,th_current_fbt_bundle_detail);
            })
          })

         //checkbox event ends

         //select element event--starts
         let th_custom_bundle_product_selecte_elements=document.querySelectorAll('.th_custom_bundle_product_selecte_element');
         th_custom_bundle_product_selecte_elements.forEach((fbt_product_grid_select_element)=>{
           fbt_product_grid_select_element.addEventListener("change",()=>{
             let th_custom_fbt_product_pricing=fbt_product_grid_select_element.closest('.th_custom_fbt_bundle_product_information').querySelector('.th_custom_fbt_product_pricing');
             let sale_price=fbt_product_grid_select_element.options[fbt_product_grid_select_element.selectedIndex].dataset.price;
             let compare_price=fbt_product_grid_select_element.options[fbt_product_grid_select_element.selectedIndex].dataset.compare_at_price;
             let selected_variant_image=fbt_product_grid_select_element.options[fbt_product_grid_select_element.selectedIndex].dataset.image;
             th_custom_fbt_product_pricing.innerHTML=th_return_fbt_product_prices(sale_price,compare_price);

             let grid_image_element=fbt_product_grid_select_element.closest('.th_cutom_fbt_bundle_product').querySelector('figure img');
             grid_image_element.src=selected_variant_image;

               let th_custom_fbt_bundle=fbt_product_grid_select_element.closest('.th_custom_fbt_bundle');
               let bundle_id=th_custom_fbt_bundle.dataset.th_custom_fbt_bid;
               let th_current_fbt_bundle_detail=wc_fbt_bundles.find((fbt_bundle)=>fbt_bundle.bundle_detail.id==bundle_id);
               let th_fbt_bundle_sale_price=0;
               let th_fbt_bundle_compare_price=0;
    
               let th_fbt_product_grids=th_custom_fbt_bundle.querySelectorAll('.th_cutom_fbt_bundle_product_containor');
               th_fbt_product_grids.forEach((fbt_product_grid)=>{
                 let th_fbt_custom_bundle_product_checkbox=fbt_product_grid.querySelector('.th_fbt_custom_bundle_product_checkbox');
                 if(th_fbt_custom_bundle_product_checkbox.checked){
                   let grid_select_element=fbt_product_grid.querySelector('.th_custom_bundle_product_selecte_element');
                   th_fbt_bundle_sale_price+=parseFloat(grid_select_element.options[grid_select_element.selectedIndex].dataset.price);
                   th_fbt_bundle_compare_price+=parseFloat(grid_select_element.options[grid_select_element.selectedIndex].dataset.compare_at_price);
                 }
               })
               let th_fbt_total_pricing_containor=th_custom_fbt_bundle.querySelector('.th_custom_fbt_bundle_total_pricing');
               th_fbt_total_pricing_containor.innerHTML=th_return_fbt_bundle_total_pricing(th_fbt_bundle_sale_price,th_fbt_bundle_compare_price,th_current_fbt_bundle_detail);
           })
         })
         //select element event--ends
         const th_custom_fbt_bundle_unique_id = function () {
           return Date.now().toString(36) + Math.random().toString(36).substr(2);
         }
           const th_custom_fbt_bundle_success_method = function (th_addtocart_result,th_current_fbt_bundle_detail,th_fbt_custom_bunle_addtocart_btn) {
              let fbt_custom_bundle_add_to_cart_btn_text=th_current_fbt_bundle_detail.bundle_detail.button_text;
              th_fbt_custom_bunle_addtocart_btn.innerHTML=fbt_custom_bundle_add_to_cart_btn_text;
              let route_url = window.Shopify.routes.root;
              if (!route_url) {
                route_url = window.Shopify.routes.root_url;
              }
              const th_bundle_cta_root_url = (Shopify && Shopify.routes && route_url) ? route_url : '/';
              if (wc_external_script_layout.direct_checkout == '2') {
                window.$th_bundle_addtocart_callback(th_addtocart_result);
              } else {
                window.location.href = window.location.origin + th_bundle_cta_root_url + 'cart';
              }
         }
         //add to cart event starts here
          const th_app_ajax_url = 'https://bundle.thimatic-apps.com/';
          const th_custom_fbt_bundle_click_analyst = function (th_addtocart_bundle_id) {
            fetch(th_app_ajax_url + 'bundle-ci/front-api/cart_click_analyst', {
              method: 'POST',
              keepalive: true,
              body: JSON.stringify({ shop: Shopify.shop, bundle_id: th_addtocart_bundle_id })
            }).then(response => response.json()).then($th_click_analyst => { }).catch(($th_click_analyst_error) => {
              console.error($th_click_analyst_error);
            });
          }
          let th_custom_fbt_bundle_add_to_cart_btns=document.querySelectorAll('.th_custom_fbt_bundle_add_to_cart_btn');
          th_custom_fbt_bundle_add_to_cart_btns.forEach((th_fbt_custom_bunle_addtocart_btn)=>{
            th_fbt_custom_bunle_addtocart_btn.addEventListener('click',async (event)=>{
              event.stopImmediatePropagation();
              let th_custom_fbt_bundle=th_fbt_custom_bunle_addtocart_btn.closest('.th_custom_fbt_bundle');
              let bundle_id=th_custom_fbt_bundle.dataset.th_custom_fbt_bid;
              let th_current_fbt_bundle_detail=wc_fbt_bundles.find((fbt_bundle)=>fbt_bundle.bundle_detail.id==bundle_id);
              let th_fbt_product_grids=th_custom_fbt_bundle.querySelectorAll('.th_cutom_fbt_bundle_product_containor');
              let th_custom_fbt_bundle_payload_items=[];
              let custom_fbt_bundle_unique_id=th_custom_fbt_bundle_unique_id();
              th_fbt_product_grids.forEach((fbt_product_grid)=>{
                 let th_fbt_custom_bundle_product_checkbox=fbt_product_grid.querySelector('.th_fbt_custom_bundle_product_checkbox');
                 if(th_fbt_custom_bundle_product_checkbox.checked){
                   let grid_select_element=fbt_product_grid.querySelector('.th_custom_bundle_product_selecte_element');
                   let selected_variant_id=grid_select_element.options[grid_select_element.selectedIndex].dataset.variant_id;
                   th_custom_fbt_bundle_payload_items.push({
                     id:selected_variant_id,
                     properties:{
                       _th_bundle_fbt:bundle_id,
                       _th_bundle_type:'fbt',
                       _th_bundle_uid:custom_fbt_bundle_unique_id
                     },
                     quantity:1
                   })
                 }
               })

               if(th_custom_fbt_bundle_payload_items.length>0){
                 th_fbt_custom_bunle_addtocart_btn.innerHTML=fbt_add_to_cart_loader;
                 th_custom_fbt_bundle_click_analyst(bundle_id);
                 const th_custom_bundle_fbt_form_data = { items: th_custom_fbt_bundle_payload_items };
                 const th_addtocart_result = await th_custom_fbt_bundle_cta_ajax_event(th_custom_bundle_fbt_form_data).then(th_addtocart_response => { return th_addtocart_response });
                  if (th_addtocart_result.items) {
                    th_custom_fbt_bundle_success_method(th_addtocart_result,th_current_fbt_bundle_detail,th_fbt_custom_bunle_addtocart_btn);
                  } else {
                    th_custom_fbt_bundle.querySelector('.th_custom_fbt_bundle_addtocart_error').innerHTML = '<p class="th_ajax_error_cls">' + th_addtocart_result.errors + '</p>';
                  }
               }
            })
          })
         //add to cart event ends here
       }
      //events ends here
    }
   }
   // client reuqerement for FBT bundle --ends  
}